// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__S6c0y","label":"styles_label__Kod18","tagList":"styles_tagList__84N_A","tag":"styles_tag__O0YBV"};